module.exports = __webpack_public_path__ + "img/LighthouseSiegeScreenshot2_1920x1080.ac4cd6fc.png";